import React from 'react';
import SectionLabel from '../ui/SectionLabel';
import FeatureCard from '../ui/FeatureCard';
import features from '../../constants/features';
import './FeaturesSection.css';

function FeaturesSection() {
  return (
    <section className="features" id="features">
      <div className="features__container">

        {/* ── Header ── */}
        <div className="features__header">
          <SectionLabel text="🌾 Everything You Need" />
          <h2 className="features__heading">
            All your farm care,<br />
            <span className="features__heading--accent">in one place.</span>
          </h2>
          <p className="features__subtext">
            From health records to smart reminders — Dhenika gives every farmer
            a complete toolkit to manage their livestock with confidence.
          </p>
        </div>

        {/* ── Grid ── */}
        <div className="features__grid">
          {features.map((feature) => (
            <FeatureCard
              key={feature.id}
              icon={feature.icon}
              iconBg={feature.iconBg}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>

      </div>
    </section>
  );
}

export default FeaturesSection;